












import Vue from "vue";
import { TabPane } from "element-ui";

export default Vue.extend({
  computed: {
    activeTabName(): string {
      return this.$route.name as string;
    }
  },
  methods: {
    onTabClick(tab: TabPane) {
      this.$router.push({
        name: tab.name
      });
    }
  }
});
